function loadView (view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

export default [
  {
    path: '',
    name: 'PlayerHome',
    component: loadView('Front/Player/Stats')
  },
  {
    path: 'awards',
    name: 'PlayerAwards',
    component: loadView('Front/Player/Awards')
  },
  {
    path: 'notices',
    name: 'PlayerNotices',
    component: loadView('Front/Player/Notices')
  },
  {
    path: 'notice/:noticeSlug',
    name: 'PlayerNotice',
    component: loadView('Front/Player/Notice')
  },
  {
    path: 'private-message',
    name: 'PlayerMessage',
    component: loadView('Front/Player/Message')
  },
  {
    path: 'record',
    name: 'PlayerRecord',
    component: loadView('Front/Player/Record')
  },
  {
    path: 'last-matches',
    name: 'PlayerLastMatches',
    component: loadView('Front/Player/LastMatches')
  }
]
